import AccountManagerEscalation from '../containers/escalations/AccountManagerEscalation';
import BillingEscalation from '../containers/escalations/BillingEscalation';
import ContractManagerEscalation from '../containers/escalations/ContractManagerEscalation';
import DeliverabilityEscalation from '../containers/escalations/DeliverabilityEscalation';
import PaymentEscalation from '../containers/escalations/PaymentEscalation';
import PrivacyEscalation from '../containers/escalations/PrivacyEscalation';
import SecurityEscalation from '../containers/escalations/SecurityEscalation';
import { ACCOUNT_MANAGER, BILLING, CONTRACT_MANAGER, DELIVERABILITY, PAYMENT, PRIVACY, SECURITY } from '../constants/EscalationType';
import { jsx as _jsx } from "react/jsx-runtime";
export function renderComponent(type) {
  switch (type) {
    case ACCOUNT_MANAGER:
      return /*#__PURE__*/_jsx(AccountManagerEscalation, {});
    case BILLING:
      return /*#__PURE__*/_jsx(BillingEscalation, {});
    case CONTRACT_MANAGER:
      return /*#__PURE__*/_jsx(ContractManagerEscalation, {});
    case DELIVERABILITY:
      return /*#__PURE__*/_jsx(DeliverabilityEscalation, {});
    case PAYMENT:
      return /*#__PURE__*/_jsx(PaymentEscalation, {});
    case PRIVACY:
      return /*#__PURE__*/_jsx(PrivacyEscalation, {});
    case SECURITY:
      return /*#__PURE__*/_jsx(SecurityEscalation, {});
    default:
      return /*#__PURE__*/_jsx("div", {});
  }
}